import { render, staticRenderFns } from "./JoinLive.vue?vue&type=template&id=15014ede&scoped=true"
import script from "./JoinLive.vue?vue&type=script&lang=js"
export * from "./JoinLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15014ede",
  null
  
)

export default component.exports